/**
 * Global authority directive
 * Used for fine-grained control of component permissions
 * @Example v-auth="RoleEnum.TEST"
 */
import type { App, Directive, DirectiveBinding } from 'vue';

import { usePermission } from '/@/hooks/web/usePermission';

function isTenantAuth(el: Element, binding: any) {
  const { hasTenantPermission } = usePermission();

  const value = binding.value;
  if (!value) return;
  if (!hasTenantPermission(value)) {
    el.parentNode?.removeChild(el);
  }
}

const mounted = (el: Element, binding: DirectiveBinding<any>) => {
  isTenantAuth(el, binding);
};

const tenantAuthDirective: Directive = {
  mounted,
};

export function setupHasDirective(app: App) {
  app.directive('has', tenantAuthDirective);
}

export default tenantAuthDirective;
